// Librerias
import React from 'react'
let PropTypes = React.PropTypes
// Componentes
import * as css from './PanelCaptador.css'
import { InputRun } from '../../../shared/input/InputRun.jsx'
import { ModalOperadorEscondido, ModalReemplazoCaptador, ModalReemplazoPorBaja, ModalTrigger } from './Modales.jsx'
// Validador Rut

const MESSAGE = "OPERADOR NO PUEDE ASISTIR CON ESTE LIDER";

export class RowOperador extends React.Component {
    constructor(props) {
        super(props)
        this.state = { checkbox: this.props.checkboxStatus }
    }
    onPressEnter(run) {
        this.ref_usuarioDV.value = ''
        this.props.agregarUsuario(run)
    }
    onRUNChange(usuarioRUN, usuarioDV) {
        // a medida que escriben el rut, se ira actualizando el DV
        this.ref_usuarioDV.value = usuarioDV
    }
    handleChangeTitular(event) {
        this.props.setStatusCheckBoxEnroqueTitular(this.props.personal.id, event.target.checked, this.props.personal.nombreCorto, this.props.personal.unidadesContadas);
        this.setState({ checkbox: event.target.checked })
    }
    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({ checkbox: nextProps.checkboxStatus });
        }
    }
    // onColorAsistencia(asistencia) {
    //     if (asistencia < 2) {
    //         return css.asistencia_0;
    //     }
    //     if (asistencia >= 2) {
    //         return css.asistencia_2;
    //     }
    // }

    // onColorAsistencia2(asistencia) {
    //     if (asistencia <= 2) {
    //         return css.asistencia_0;
    //     }
    //     if (asistencia == 3) {
    //         return css.asistencia_3;
    //     }

    //     if (asistencia == 4) {
    //         return css.asistencia_4;
    //     }
    //     if (asistencia == 5) {
    //         return css.asistencia_5;
    //     }
    // }
    getIconAsistencia(asistencia) {
        if (asistencia < 2) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-x-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
            </svg>;
        }
        if (asistencia >= 2) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-check-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </svg>;
        }
    }
    getIconAsistencia2(asistencia) {
        if (asistencia <= 2) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-x-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
            </svg>;
        }
        if (asistencia == 3) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-car-front-fill" viewBox="0 0 16 16">
                <path d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679q.05.242.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.8.8 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17s3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z" />
            </svg>;
        }

        if (asistencia == 4) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-car-front-fill" viewBox="0 0 16 16">
                <path d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679q.05.242.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.8.8 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17s3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z" />
            </svg>;
        }
        if (asistencia == 5) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-shop" viewBox="0 0 16 16">
                <path d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.37 2.37 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0M1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5M4 15h3v-5H4zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zm3 0h-2v3h2z" />
            </svg>;
        }
    }
    getIconStyle(asistencia) {
        if (asistencia < 2) {
            return { color: 'red' };
        }
        if (asistencia >= 2) {
            return { color: 'green' };
        }
    }
    getIconStyle2(asistencia) {
        if (asistencia <= 2) {
            return { color: 'red' };
        }
        if (asistencia == 3) {
            return { color: 'red' };
        }
        if (asistencia == 4) {
            return { color: 'green' };
        }
        if (asistencia == 5) {
            return { color: 'green' };
        }
    }
    render() {
        const isPermisoMall = this.props.isPermisoMall;
        if (this.props.personal) {
            const tienePermisoMall = this.props.tienePermisoMall ? this.props.tienePermisoMall : false
            // si el operador esta definido, mostrar sus datos
            const isBaja = this.props.personal.asistencia == "-1";
            return (
                <tr key={1} style={{ backgroundColor: (isBaja ? '#fa9c9a' : '') }}>
                    <td>{this.props.correlativo}</td>
                    <td className={css.tdUsuarioRUN}>
                        {this.props.personal.bloqueadoLider
                            ? <p className={css.textoConTooltip} style={{ overflow: 'hidden' }} >
                                <strong style={{ color: 'darkviolet' }}>
                                    <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                </strong>
                                <span>{MESSAGE}</span>
                            </p> :
                            this.props.personal.bloqueado
                                ? <strong style={{ color: 'red' }}>
                                    <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                </strong> :
                                (this.props.personal.bloqueadoCliente
                                    ? <strong style={{ color: 'orange' }}>
                                        <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                    </strong> :
                                    <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                )
                        }
                    </td>
                    <td className={css.tdUsuarioDV}>
                        {this.props.personal.bloqueado
                            ? <strong style={{ color: 'red' }}>
                                <input type="text" value={this.props.personal.usuarioDV} disabled />
                            </strong> :
                            (this.props.personal.bloqueadoCliente
                                ? <strong style={{ color: 'orange' }}>
                                    <input type="text" value={this.props.personal.usuarioDV} disabled />
                                </strong> :
                                <input type="text" value={this.props.personal.usuarioDV} disabled />
                            )
                        }
                    </td>
                    <td className={css.tdNombre}>
                        <input type="text" value={this.props.personal.nombreCompleto} disabled />
                    </td>
                    <td>
                        {this.props.cargo}
                    </td>
                    <td>
                        {this.props.personal.comuna}
                    </td>
                    <td className={css.tdCaptador}>
                        {this.props.personal.captador}
                    </td>
                    <td>
                        {this.props.cargo == 'Lider' ? `${this.props.personal.experienciaComoLider}` : ''}
                        {this.props.cargo == 'Supervisor' ? `${this.props.personal.experienciaComoSupervisor}` : ''}
                        {this.props.cargo == 'Operador' ? `${this.props.personal.experienciaComoOperador}` : ''}
                    </td>
                    <td className={css.tdError}>
                        {this.props.personal.error ? (this.props.personal.error >= 1 ? <strong style={{ color: 'red' }}>{this.props.personal.error}</strong> : this.props.personal.error) : 0}
                    </td>
                    <td className={css.tdConteo}>
                        {this.props.personal.unidadesContadas ? this.props.personal.unidadesContadas : ''}
                    </td>
                    <td className={css.tdConteoReal}>
                        {this.props.personal.unidadesContadasReal ? this.props.personal.unidadesContadasReal : ''}
                    </td>
                    <td className={this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? css.aprobado_2 : this.props.personal.idEstadoContrato == 2 ? css.aprobado_1 : this.props.personal.idEstadoContrato == 1 ? css.pendiente_2 : css.pendiente_3}>
                        {this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? 'Aprobado' : this.props.personal.idEstadoContrato == 2 ? 'Vigente' : this.props.personal.idEstadoContrato == 1 ? 'Pendiente' : 'Pendiente'}
                    </td>
                    <td>
                        <span title={this.props.personal.estadoCI}>
                            {this.props.personal.estadoCI === 'Vigente' && <span className={css.emoji_verde}>✅</span>}
                            {this.props.personal.estadoCI === 'Próximo a vencer' && <span className={css.emoji_amarillo}>⚠️</span>}
                            {this.props.personal.estadoCI === 'Vencido' && <span className={css.emoji_rojo}>❌</span>}
                            {!['Vigente', 'Próximo a vencer', 'Vencido'].includes(this.props.personal.estadoCI) &&
                                <span className={css.emoji_gris}>⚪</span>
                            }
                        </span>
                    </td>
                    {isPermisoMall ? <td>
                        {tienePermisoMall
                            ? <div className='glyphicon glyphicon-ok' style={{ color: 'green', fontSize: '16px' }}></div>
                            : <div className='glyphicon glyphicon-remove' style={{ color: 'red', fontSize: '16px' }}></div>
                        }
                    </td> : null}
                    <td>
                        {this.props.editable ?
                            <button className="btn btn-xs btn-warning glyphicon glyphicon-remove"
                                onClick={() => { this.props.quitarUsuario(this.props.personal.id, true) }}
                                title="Quitar Operador"
                            ></button>
                            :
                            null
                        }
                    </td>
                    <td>
                        {(this.props.editable && this.props.cargo == 'Operador') ?
                            <button className="btn btn-xs btn-info glyphicon glyphicon-triangle-right" disabled={this.props.operadorTitularId}
                                onClick={() => { this.props.cambiarDePanel(this.props.personal.id, true, this.props.idCaptador) }}
                            ></button>
                            : (this.props.enroque ?
                                <input type="checkbox" onChange={this.handleChangeTitular.bind(this)} checked={this.state.checkbox} />
                                : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 'large' }}>
                                    <i style={this.getIconStyle(this.props.personal.asistencia)}>
                                        {this.getIconAsistencia(this.props.personal.asistencia)}
                                    </i>
                                </div>
                            )
                        }
                    </td>
                    <td>
                        {(this.props.editable && this.props.cargo == 'Operador')
                            ? null
                            : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 'large' }}>
                                <i style={this.getIconStyle2(this.props.personal.asistencia)}>
                                    {this.getIconAsistencia2(this.props.personal.asistencia)}
                                </i>
                            </div>
                        }
                    </td>
                </tr>
            )
        }
        else if (this.props.sumaUnidades) {
            return (
                <tr key={3}>
                    <td>{this.props.correlativo}</td>
                    <td>
                        {<b>Conteo</b>}
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td className={css.tdConteo}>
                        {this.props.sumaUnidades}
                    </td>
                    <td></td>
                    {isPermisoMall ? <td></td> : null}
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            )
        }
        else if (this.props.diferenciaUnidades) {
            return (
                <tr key={4}>
                    <td>{this.props.correlativo}</td>
                    <td>
                        {<b>Direrencia</b>}
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td className={css.tdDiferencia}>
                        {this.props.diferenciaUnidades}
                    </td>
                    <td></td>
                    {isPermisoMall ? <td></td> : null}
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            )
        }
        else {
            // si no esta definido, mostrar el formulario para agregarlo
            return (
                <tr key={2}>
                    <td>{this.props.correlativo}</td>
                    <td className={css.tdUsuarioRUN}>
                        {this.props.editable ?
                            <InputRun key={1}
                                onPressEnter={this.onPressEnter.bind(this)}
                                onRUNChange={this.onRUNChange.bind(this)}
                            />
                            :
                            <input type="text" key={2} disabled />
                        }
                    </td>
                    <td className={css.tdUsuarioDV}>
                        <input type="text" value={''} disabled ref={ref => this.ref_usuarioDV = ref} />
                    </td>
                    <td className={css.tdNombre}>
                        <input type="text" value={''} disabled />
                    </td>
                    <td>
                        {this.props.cargo}
                    </td>
                    <td>
                        {/* Comuna */}
                    </td>
                    <td>
                        {/* Captador */}
                    </td>
                    <td>
                        {/* experiencia */}
                    </td>
                    <td>
                        {/* Unidades */}
                    </td>
                    <td>
                        {/* Error */}
                    </td>
                    <td>
                        {/* Unidades Real */}
                    </td>
                    {isPermisoMall ? <td></td> : null}
                    <td>
                        {/*<a href="#" className="btn btn-small">Quitar</a>*/}
                    </td>
                    <td></td>
                    <td>
                        {/*<a href="#" className="btn btn-small">Cambiar</a>*/}
                    </td>
                </tr>
            )
        }
    }
}
RowOperador.propTypes = {
    editable: PropTypes.bool.isRequired,
    //editarTodasNominas: PropTypes.bool.isRequired,
    correlativo: PropTypes.string.isRequired,
    personal: PropTypes.object,
    cargo: PropTypes.string,
    enroque: PropTypes.bool
}


export class RowOperadorSEI extends React.Component {
    constructor(props) {
        super(props)
        this.state = { checkbox: this.props.checkboxStatus }
    }
    onPressEnter(run) {
        this.ref_usuarioDV.value = ''
        this.props.agregarUsuario(run)
    }
    onRUNChange(usuarioRUN, usuarioDV) {
        // a medida que escriben el rut, se ira actualizando el DV
        this.ref_usuarioDV.value = usuarioDV
    }
    handleChangeTitular(event) {
        this.props.setStatusCheckBoxEnroqueTitular(this.props.personal.id, event.target.checked, this.props.personal.nombreCorto, this.props.personal.unidadesContadas);
        this.setState({ checkbox: event.target.checked })
    }
    // onColorAsistencia(asistencia) {
    //     /*if (asistencia == 0) {
    //         return css.asistencia_0;
    //     }
    //     if (asistencia == 1) {
    //         return css.asistencia_1;
    //     }*/
    //     if (asistencia < 2) {
    //         return css.asistencia_0;
    //     }
    //     if (asistencia >= 2) {
    //         return css.asistencia_2;
    //     }
    // }

    // onColorAsistencia2(asistencia) {
    //     if (asistencia <= 2) {
    //         return css.asistencia_0;
    //     }
    //     if (asistencia == 3) {
    //         return css.asistencia_3;
    //     }

    //     if (asistencia == 4) {
    //         return css.asistencia_4;
    //     }
    //     if (asistencia == 5) {
    //         return css.asistencia_5;
    //     }
    // }
    getIconAsistencia(asistencia) {
        if (asistencia < 2) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-x-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
            </svg>;
        }
        if (asistencia >= 2) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-check-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </svg>;
        }
    }
    getIconAsistencia2(asistencia) {
        if (asistencia <= 2) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-x-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
            </svg>;
        }
        if (asistencia == 3) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-car-front-fill" viewBox="0 0 16 16">
                <path d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679q.05.242.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.8.8 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17s3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z" />
            </svg>;
        }

        if (asistencia == 4) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-car-front-fill" viewBox="0 0 16 16">
                <path d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679q.05.242.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.8.8 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17s3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z" />
            </svg>;
        }
        if (asistencia == 5) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-shop" viewBox="0 0 16 16">
                <path d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.37 2.37 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0M1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5M4 15h3v-5H4zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zm3 0h-2v3h2z" />
            </svg>;
        }
    }
    getIconStyle(asistencia) {
        if (asistencia < 2) {
            return { color: 'red' };
        }
        if (asistencia >= 2) {
            return { color: 'green' };
        }
    }
    getIconStyle2(asistencia) {
        if (asistencia <= 2) {
            return { color: 'red' };
        }
        if (asistencia == 3) {
            return { color: 'red' };
        }
        if (asistencia == 4) {
            return { color: 'green' };
        }
        if (asistencia == 5) {
            return { color: 'green' };
        }
    }
    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({ checkbox: nextProps.checkboxStatus });
        }
    }
    render() {
        const isPermisoMall = this.props.isPermisoMall;
        if (this.props.personal) {
            const tienePermisoMall = this.props.tienePermisoMall ? this.props.tienePermisoMall : false
            // si el operador esta definido, mostrar sus datos
            const isBaja = this.props.personal.asistencia == "-1";
            return (
                <tr key={1} style={{ backgroundColor: (isBaja ? '#fa9c9a' : '') }}>
                    <td>{this.props.correlativo}</td>
                    <td className={css.tdUsuarioRUN}>
                        {this.props.personal.bloqueadoLider
                            ? <p className={css.textoConTooltip} style={{ overflow: 'hidden' }} >
                                <strong style={{ color: 'darkviolet' }}>
                                    <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                </strong>
                                <span>{MESSAGE}</span>
                            </p> :
                            this.props.personal.bloqueado
                                ? <strong style={{ color: 'red' }}>
                                    <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                </strong> :
                                (this.props.personal.bloqueadoCliente
                                    ? <strong style={{ color: 'orange' }}>
                                        <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                    </strong> :
                                    <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                )
                        }
                    </td>
                    <td className={css.tdUsuarioDV}>
                        {this.props.personal.bloqueadoLider
                            ? <strong style={{ color: 'darkviolet' }}>
                                <input type="text" value={this.props.personal.usuarioDV} disabled />
                            </strong> : this.props.personal.bloqueado
                                ? <strong style={{ color: 'red' }}>
                                    <input type="text" value={this.props.personal.usuarioDV} disabled />
                                </strong> :
                                (this.props.personal.bloqueadoCliente
                                    ? <strong style={{ color: 'orange' }}>
                                        <input type="text" value={this.props.personal.usuarioDV} disabled />
                                    </strong> :
                                    <input type="text" value={this.props.personal.usuarioDV} disabled />
                                )
                        }
                    </td>
                    <td className={css.tdNombre}>
                        <input type="text" value={this.props.personal.nombreCompleto} disabled />

                    </td>
                    <td>
                        {this.props.cargo}
                    </td>
                    <td>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <div>{this.props.personal.comuna}</div>
                            {!this.props.personal.existeTarifa && this.props.cargo == "Operador"
                                ? <div className={css.textoConTooltip}>
                                    <div className='glyphicon glyphicon-usd' style={{ color: 'red', fontSize: 14 }}></div>
                                    <span>
                                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                                            {`${this.props.personal.comuna}-${this.props.comunaInventario}: Tarifa no existe`}
                                        </div>
                                    </span>
                                </div>
                                : null}
                        </div>
                    </td>
                    <td className={css.tdCaptador}>
                        {this.props.personal.captador}
                    </td>
                    <td>
                        {this.props.cargo == 'Lider' ? `${this.props.personal.experienciaComoLider}` : ''}
                        {this.props.cargo == 'Supervisor' ? `${this.props.personal.experienciaComoSupervisor}` : ''}
                        {this.props.cargo == 'Operador' ? `${this.props.personal.experienciaComoOperador}` : ''}
                    </td>
                    <td className={css.tdError}>
                        {this.props.personal.error ? (this.props.personal.error >= 1 ? <strong style={{ color: 'red' }}>{this.props.personal.error}</strong> : this.props.personal.error) : 0}
                    </td>
                    <td className={css.tdConteo}>
                        {this.props.personal.unidadesContadas ? this.props.personal.unidadesContadas : ''}
                    </td>
                    <td className={css.tdConteoReal}>
                        {this.props.personal.unidadesContadasReal ? this.props.personal.unidadesContadasReal : ''}
                    </td>
                    <td className={this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? css.aprobado_2 : this.props.personal.idEstadoContrato == 2 ? css.aprobado_1 : this.props.personal.idEstadoContrato == 1 ? css.pendiente_2 : css.pendiente_3}>
                        {this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? 'Aprobado' : this.props.personal.idEstadoContrato == 2 ? 'Vigente' : this.props.personal.idEstadoContrato == 1 ? 'Pendiente' : 'Pendiente'}
                    </td>
                    <td>
                        <span title={this.props.personal.estadoCI}>
                            {this.props.personal.estadoCI === 'Vigente' && <span className={css.emoji_verde}>✅</span>}
                            {this.props.personal.estadoCI === 'Próximo a vencer' && <span className={css.emoji_amarillo}>⚠️</span>}
                            {this.props.personal.estadoCI === 'Vencido' && <span className={css.emoji_rojo}>❌</span>}
                            {!['Vigente', 'Próximo a vencer', 'Vencido'].includes(this.props.personal.estadoCI) &&
                                <span className={css.emoji_gris}>⚪</span>
                            }
                        </span>
                    </td>
                    {isPermisoMall ? <td>
                        {tienePermisoMall
                            ? <div className='glyphicon glyphicon-ok' style={{ color: 'green', fontSize: '16px' }}></div>
                            : <div className='glyphicon glyphicon-remove' style={{ color: 'red', fontSize: '16px' }}></div>
                        }
                    </td> : null}
                    {this.props.activarPermisoMall
                        ?
                        <td key={'A1'} colSpan="3">
                            <InputOperadorPermisoMall
                                disabled={tienePermisoMall}
                                idNomina={this.props.idNomina}
                                idOperador={this.props.personal.id}
                                incluir_permisomall={this.props.personal.incluir_permisomall}
                                selectedPermisoId={this.props.selectedPermisoId}
                                permisoCompleto={this.props.permisoCompleto}
                                notificator={this.props.notificator}
                            />
                        </td>

                        : [<td key={'B1'}>
                            {this.props.editable ?
                                <button className="btn btn-xs btn-warning glyphicon glyphicon-remove"
                                    onClick={() => { this.props.quitarUsuario(this.props.personal.id, true) }}
                                    title="Quitar Operador"
                                ></button>
                                :
                                null
                            }
                        </td>,
                        <td key={'B2'}>
                            {this.props.editable && this.props.cargo == 'Operador' ?
                                <button className="btn btn-xs btn-danger glyphicon glyphicon-ban-circle" disabled={this.props.operadorTitularId}
                                    onClick={() => { this.props.blockOperador(this.props.personal, this.props.idNomina) }}
                                    title="Bloquear Operador"
                                ></button>
                                : this.props.cargo == "Operador"
                                    ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 'large' }}>
                                        <i style={this.getIconStyle(this.props.personal.asistencia)}>
                                            {this.getIconAsistencia(this.props.personal.asistencia)}
                                        </i>
                                    </div>
                                    : null

                            }
                        </td>,
                        <td key={'B3'}>
                            {(this.props.editable && this.props.cargo == 'Operador') ?
                                <button className="btn btn-xs btn-info glyphicon glyphicon-triangle-right" disabled={this.props.operadorTitularId}
                                    onClick={() => { this.props.cambiarDePanel(this.props.personal.id, true, this.props.personal.idCaptador) }}
                                ></button>
                                :
                                (this.props.enroque ?
                                    <input type="checkbox" onChange={this.handleChangeTitular.bind(this)} checked={this.state.checkbox} />
                                    : this.props.cargo == "Operador"
                                        ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 'large' }}>
                                            <i style={this.getIconStyle2(this.props.personal.asistencia)}>
                                                {this.getIconAsistencia2(this.props.personal.asistencia)}
                                            </i>
                                        </div>
                                        : null)
                            }
                        </td>]}
                </tr>
            )
        }
        else if (this.props.sumaUnidades) {
            return (
                <tr key={3}>
                    <td>{this.props.correlativo}</td>
                    <td>
                        {<b>Conteo</b>}
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td className={css.tdConteo}>
                        {this.props.sumaUnidades}
                    </td>
                    <td className={css.tdConteo}>
                        {this.props.sumaConteo}
                    </td>
                    <td></td>
                    {isPermisoMall ? <td></td> : null}
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            )
        }
        else if (this.props.diferenciaUnidades) {
            return (
                <tr key={4}>
                    <td>{this.props.correlativo}</td>
                    <td>
                        {<b>Direrencia</b>}
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td className={css.tdDiferencia}>
                        {this.props.diferenciaUnidades}
                    </td>
                    <td className={css.tdDiferencia}>
                        {this.props.diferenciaConteo}
                    </td>
                    <td></td>
                    {isPermisoMall ? <td></td> : null}
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            )
        }
        else {
            // si no esta definido, mostrar el formulario para agregarlo
            return (
                <tr key={2}>
                    <td>{this.props.correlativo}</td>
                    <td className={css.tdUsuarioRUN}>
                        {this.props.editable ?
                            <InputRun key={1}
                                onPressEnter={this.onPressEnter.bind(this)}
                                onRUNChange={this.onRUNChange.bind(this)}
                            />
                            :
                            <input type="text" key={2} disabled />
                        }
                    </td>
                    <td className={css.tdUsuarioDV}>
                        <input type="text" value={''} disabled ref={ref => this.ref_usuarioDV = ref} />
                    </td>
                    <td className={css.tdNombre}>
                        <input type="text" value={''} disabled />
                    </td>
                    <td>
                        {this.props.cargo}
                    </td>
                    <td>
                        {/* Comuna */}
                    </td>
                    <td>
                        {/* Captador */}
                    </td>
                    <td>
                        {/* experiencia */}
                    </td>
                    <td>
                        {/* Unidades */}
                    </td>
                    <td>
                        {/* Error */}
                    </td>
                    <td></td>
                    {isPermisoMall ? <td></td> : null}
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            )
        }
    }
}

RowOperadorSEI.propTypes = {
    editable: PropTypes.bool.isRequired,
    //editarTodasNominas: PropTypes.bool.isRequired,
    correlativo: PropTypes.string.isRequired,
    personal: PropTypes.object,
    cargo: PropTypes.string,
    enroque: PropTypes.bool
}

export class RowOperadorSEIEscondido extends React.Component {
    constructor(props) {
        super(props)
        this.state = { checkbox: this.props.checkboxStatus }
    }

    getIconAsistencia(asistencia) {
        if (asistencia < 2) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-x-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
            </svg>;
        }
        if (asistencia >= 2) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-check-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </svg>;
        }
    }
    getIconAsistencia2(asistencia) {
        if (asistencia <= 2) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-x-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
            </svg>;
        }
        if (asistencia == 3) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-car-front-fill" viewBox="0 0 16 16">
                <path d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679q.05.242.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.8.8 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17s3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z" />
            </svg>;
        }

        if (asistencia == 4) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-car-front-fill" viewBox="0 0 16 16">
                <path d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679q.05.242.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.8.8 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17s3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z" />
            </svg>;
        }
        if (asistencia == 5) {
            return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-shop" viewBox="0 0 16 16">
                <path d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.37 2.37 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0M1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5M4 15h3v-5H4zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zm3 0h-2v3h2z" />
            </svg>;
        }
    }
    getIconStyle(asistencia) {
        if (asistencia < 2) {
            return { color: 'red' };
        }
        if (asistencia >= 2) {
            return { color: 'green' };
        }
    }
    getIconStyle2(asistencia) {
        if (asistencia <= 2) {
            return { color: 'red' };
        }
        if (asistencia == 3) {
            return { color: 'red' };
        }
        if (asistencia == 4) {
            return { color: 'green' };
        }
        if (asistencia == 5) {
            return { color: 'green' };
        }
    }
    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({ checkbox: nextProps.checkboxStatus });
        }
    }
    render() {
        const isPermisoMall = this.props.isPermisoMall;
        if (this.props.personal) {
            const tienePermisoMall = this.props.tienePermisoMall ? this.props.tienePermisoMall : false
            // si el operador esta definido, mostrar sus datos
            const isBaja = this.props.personal.asistencia == "-1";
            return (
                <tr key={1} style={{ backgroundColor: (isBaja ? '#fa9c9a' : '') }}>
                    <td>{this.props.correlativo}</td>
                    <td className={css.tdUsuarioRUN}>
                        {this.props.personal.bloqueadoLider
                            ? <p className={css.textoConTooltip} style={{ overflow: 'hidden' }} >
                                <strong style={{ color: 'darkviolet' }}>
                                    <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                </strong>
                                <span>{MESSAGE}</span>
                            </p> :
                            this.props.personal.bloqueado
                                ? <strong style={{ color: 'red' }}>
                                    <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                </strong> :
                                (this.props.personal.bloqueadoCliente
                                    ? <strong style={{ color: 'orange' }}>
                                        <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                    </strong> :
                                    <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                )
                        }
                    </td>
                    <td className={css.tdUsuarioDV}>
                        {this.props.personal.bloqueadoLider
                            ? <strong style={{ color: 'darkviolet' }}>
                                <input type="text" value={this.props.personal.usuarioDV} disabled />
                            </strong> : this.props.personal.bloqueado
                                ? <strong style={{ color: 'red' }}>
                                    <input type="text" value={this.props.personal.usuarioDV} disabled />
                                </strong> :
                                (this.props.personal.bloqueadoCliente
                                    ? <strong style={{ color: 'orange' }}>
                                        <input type="text" value={this.props.personal.usuarioDV} disabled />
                                    </strong> :
                                    <input type="text" value={this.props.personal.usuarioDV} disabled />
                                )
                        }
                    </td>
                    <td className={css.tdNombre}>
                        <input type="text" value={this.props.personal.nombreCompleto} disabled />

                    </td>
                    <td>
                        {this.props.cargo}
                    </td>
                    <td>
                        {this.props.personal.comuna}
                    </td>
                    <td className={css.tdCaptador}>
                        {this.props.personal.captador}
                    </td>
                    <td>
                        {this.props.cargo == 'Lider' ? `${this.props.personal.experienciaComoLider}` : ''}
                        {this.props.cargo == 'Supervisor' ? `${this.props.personal.experienciaComoSupervisor}` : ''}
                        {this.props.cargo == 'Operador' ? `${this.props.personal.experienciaComoOperador}` : ''}
                    </td>
                    <td className={css.tdError}>
                        {this.props.personal.error ? (this.props.personal.error >= 1 ? <strong style={{ color: 'red' }}>{this.props.personal.error}</strong> : this.props.personal.error) : 0}
                    </td>
                    <td className={css.tdConteo}>
                        {this.props.personal.unidadesContadas ? this.props.personal.unidadesContadas : ''}
                    </td>
                    <td className={css.tdConteoReal}>
                        {this.props.personal.unidadesContadasReal ? this.props.personal.unidadesContadasReal : ''}
                    </td>
                    <td className={this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? css.aprobado_2 : this.props.personal.idEstadoContrato == 2 ? css.aprobado_1 : this.props.personal.idEstadoContrato == 1 ? css.pendiente_2 : css.pendiente_3}>
                        {this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? 'Aprobado' : this.props.personal.idEstadoContrato == 2 ? 'Vigente' : this.props.personal.idEstadoContrato == 1 ? 'Pendiente' : 'Pendiente'}
                    </td>
                    <td>
                        <span title={this.props.personal.estadoCI}>
                            {this.props.personal.estadoCI === 'Vigente' && <span className={css.emoji_verde}>✅</span>}
                            {this.props.personal.estadoCI === 'Próximo a vencer' && <span className={css.emoji_amarillo}>⚠️</span>}
                            {this.props.personal.estadoCI === 'Vencido' && <span className={css.emoji_rojo}>❌</span>}
                            {!['Vigente', 'Próximo a vencer', 'Vencido'].includes(this.props.personal.estadoCI) &&
                                <span className={css.emoji_gris}>⚪</span>
                            }
                        </span>
                    </td>
                    {isPermisoMall ? <td>
                        {tienePermisoMall
                            ? <div className='glyphicon glyphicon-ok' style={{ color: 'green', fontSize: '16px' }}></div>
                            : <div className='glyphicon glyphicon-remove' style={{ color: 'red', fontSize: '16px' }}></div>
                        }
                    </td> : null}
                    {this.props.activarPermisoMall
                        ?
                        <td key={'A1'} colSpan="3">
                            <InputOperadorPermisoMall
                                idNomina={this.props.idNomina}
                                idOperador={this.props.personal.id}
                                incluir_permisomall={this.props.personal.incluir_permisomall}
                                //selectedPermisoId={this.props.selectedPermisoId}
                                permisoCompleto={this.props.permisoCompleto}
                                notificator={this.props.notificator}
                            />
                        </td>

                        : [<td key={'B1'}>
                            {/* {this.props.editable ?
                            <button className="btn btn-xs btn-warning glyphicon glyphicon-remove"
                                onClick={() => { this.props.quitarUsuario(this.props.personal.id, true) }}
                                title="Quitar Operador"
                            ></button>
                            :
                            null
                        } */}
                        </td>,
                        <td key={'B2'}>
                            {/* {this.props.editable && this.props.cargo == 'Operador' ?
                            <button className="btn btn-xs btn-danger glyphicon glyphicon-ban-circle" disabled={this.props.operadorTitularId}
                                onClick={() => { this.props.blockOperador(this.props.personal, this.props.idNomina) }}
                                title="Bloquear Operador"
                            ></button>
                            : this.props.cargo == "Operador"
                                ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 'large' }}>
                                    <i style={this.getIconStyle(this.props.personal.asistencia)}>
                                        {this.getIconAsistencia(this.props.personal.asistencia)}
                                    </i>
                                </div>
                                : null

                        } */}
                        </td>,
                        <td key={'B3'}>
                            {(this.props.editable && this.props.cargo == 'Operador') ?
                                <button className="btn btn-xs btn-info glyphicon glyphicon-triangle-right"
                                    onClick={() => { this.props.quitarEscondido(this.props.personal.id) }}
                                ></button>
                                : null
                                // (this.props.enroque ?
                                //     <input type="checkbox" onChange={this.handleChangeTitular.bind(this)} checked={this.state.checkbox} />
                                //     : this.props.cargo == "Operador"
                                //         ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 'large' }}>
                                //             <i style={this.getIconStyle2(this.props.personal.asistencia)}>
                                //                 {this.getIconAsistencia2(this.props.personal.asistencia)}
                                //             </i>
                                //         </div>
                                //         : null)
                            }
                        </td>]}
                </tr>
            )
        }
    }
}

RowOperadorSEIEscondido.propTypes = {
    editable: PropTypes.bool.isRequired,
    //editarTodasNominas: PropTypes.bool.isRequired,
    correlativo: PropTypes.string.isRequired,
    personal: PropTypes.object,
    cargo: PropTypes.string,
    enroque: PropTypes.bool
}

// REEMPLAZOS

export class RowOperadorReemplazo extends React.Component {
    constructor(props) {
        super(props)
        this.state = { showModal: false }
    }
    handleClick() {
        const fechaInventario = new Date(`${this.props.fechaInventario}T09:00:00`);
        const fechaActual = new Date();
        if (fechaInventario.toDateString() === fechaActual.toDateString() && fechaActual > fechaInventario) {
            this.setState({ showModal: true })
        } else {
            this.setState({ showModal: false })
            this.props.cambiarDePanel(this.props.personal.id, false, this.props.personal.idCaptador);
        }
    }
    hideModal() {
        this.setState({ showModal: false })
    }
    onPressEnter(run) {
        this.ref_usuarioDV.value = ''
        this.props.agregarUsuario(run)
    }
    onRUNChange(usuarioRUN, usuarioDV) {
        // a medida que escriben el rut, se ira actualizando el DV
        this.ref_usuarioDV.value = usuarioDV
    }
    handleChangeEnroque(event) {
        this.props.setStatusCheckBoxEnroqueReemplazo(this.props.personal.id, event.target.checked, this.props.personal.nombreCorto, this.props.personal.unidadesContadas);
        this.setState({ checkbox: event.target.checked })
    }
    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({ checkbox: nextProps.checkboxStatus });
        }
    }
    render() {
        if (this.props.personal) {
            const isPermisoMall = this.props.isPermisoMall;
            const tienePermisoMall = this.props.tienePermisoMall ? this.props.tienePermisoMall : false
            // console.log(this.props.personal);
            // si el operador esta definido, mostrar sus datos
            return (
                <tr key={1}>
                    <td>
                        {this.state.showModal && <ModalReemplazoPorBaja cambiarPanel={this.props.cambiarDePanel} id={this.props.personal.id}
                            captador={this.props.idCaptador} hideModal={this.hideModal.bind(this)} operador={this.props.personal.nombreCorto} />}
                        {this.props.editable && this.props.cargo == 'Operador' ?
                            <button className="btn btn-xs btn-success glyphicon glyphicon-triangle-left"
                                onClick={this.handleClick.bind(this)}
                                title="Cambiar a nómina titular"
                            >
                            </button>
                            :
                            (this.props.enroque ?
                                <input type="checkbox" onChange={this.handleChangeEnroque.bind(this)} checked={this.state.checkbox} />
                                : null)
                        }
                    </td>
                    <td>
                        {this.props.editable ?
                            <button className="btn btn-xs btn-warning glyphicon glyphicon-remove" disabled={this.props.operadorTitularId}
                                onClick={() => { this.props.quitarUsuario(this.props.personal.id, false) }}
                                title="Quitar Operador nómina reemplazo"
                            ></button>
                            :
                            null
                        }
                    </td>
                    <td>
                        {this.props.editable ?
                            <button className="btn btn-xs btn-warning glyphicon glyphicon-ban-circle" disabled={this.props.operadorTitularId}
                                onClick={() => { this.props.suspendOperator(this.props.personal) }}
                                title="Suspender operador"
                            ></button>
                            :
                            null
                        }
                    </td>
                    <td className={css.tdUsuarioRUN}>
                        {this.props.personal.bloqueadoLider
                            ? <p className={css.textoConTooltip} style={{ overflow: 'hidden' }} >
                                <strong style={{ color: 'darkviolet' }}>
                                    <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                </strong>
                                <span>{MESSAGE}</span>
                            </p> : this.props.personal.bloqueado
                                ? <strong style={{ color: 'red' }}>
                                    <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                </strong> :
                                (this.props.personal.bloqueadoCliente
                                    ? <strong style={{ color: 'orange' }}>
                                        <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                    </strong> :
                                    <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                )
                        }
                    </td>
                    <td className={css.tdUsuarioDV}>
                        {this.props.personal.bloqueadoLider
                            ? <strong style={{ color: 'darkviolet' }}>
                                <input type="text" value={this.props.personal.usuarioDV} disabled />
                            </strong> : this.props.personal.bloqueado
                                ? <strong style={{ color: 'red' }}>
                                    <input type="text" value={this.props.personal.usuarioDV} disabled />
                                </strong> :
                                (this.props.personal.bloqueadoCliente
                                    ? <strong style={{ color: 'orange' }}>
                                        <input type="text" value={this.props.personal.usuarioDV} disabled />
                                    </strong> :
                                    <input type="text" value={this.props.personal.usuarioDV} disabled />
                                )
                        }
                    </td>


                    <td className={this.props.personal.idnominatitular > 0 ? css.operadorEnOtraNominaMismoDia : css.tdNombre}>

                        {this.props.personal.idnominatitular > 0 ?
                            <p className={css.textoConTooltip}  >
                                <input type="text" value={this.props.personal.nombreCorto} disabled />
                                <span>{this.props.personal.datos_nomina_titular}</span>
                            </p>
                            :
                            <input type="text" value={this.props.personal.nombreCorto} disabled />
                        }

                    </td>
                    <td>
                        {this.props.personal.comuna}
                    </td>
                    <td className={css.tdCaptador}>
                        {this.props.personal.captador}
                    </td>
                    <td>
                        {this.props.cargo == 'Lider' ? `${this.props.personal.experienciaComoLider}` : ''}
                        {this.props.cargo == 'Supervisor' ? `${this.props.personal.experienciaComoSupervisor}` : ''}
                        {this.props.cargo == 'Operador' ? `${this.props.personal.experienciaComoOperador}` : ''}
                    </td>
                    <td className={css.tdError}>
                        {this.props.personal.error ? (this.props.personal.error >= 1 ? <strong style={{ color: 'red' }}>{this.props.personal.error}</strong> : this.props.personal.error) : 0}
                    </td>
                    <td className={css.tdConteo}>
                        {this.props.personal.unidadesContadas ? this.props.personal.unidadesContadas : ''}
                    </td>
                    <td className={css.tdConteoReal}>
                        {this.props.personal.unidadesContadasReal ? this.props.personal.unidadesContadasReal : ''}
                    </td>
                    <td className={this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? css.aprobado_2 : this.props.personal.idEstadoContrato == 2 ? css.aprobado_1 : this.props.personal.idEstadoContrato == 1 ? css.pendiente_2 : css.pendiente_3}>
                        {this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? 'Aprobado' : this.props.personal.idEstadoContrato == 2 ? 'Vigente' : this.props.personal.idEstadoContrato == 1 ? 'Pendiente' : 'Pendiente'}
                    </td>
                    <td>
                        <span title={this.props.personal.estadoCI}>
                            {this.props.personal.estadoCI === 'Vigente' && <span className={css.emoji_verde}>✅</span>}
                            {this.props.personal.estadoCI === 'Próximo a vencer' && <span className={css.emoji_amarillo}>⚠️</span>}
                            {this.props.personal.estadoCI === 'Vencido' && <span className={css.emoji_rojo}>❌</span>}
                            {!['Vigente', 'Próximo a vencer', 'Vencido'].includes(this.props.personal.estadoCI) &&
                                <span className={css.emoji_gris}>⚪</span>
                            }
                        </span>
                    </td>
                    {isPermisoMall ? <td>
                        {tienePermisoMall
                            ? <div className='glyphicon glyphicon-ok' style={{ color: 'green', fontSize: '16px' }}></div>
                            : <div className='glyphicon glyphicon-remove' style={{ color: 'red', fontSize: '16px' }}></div>
                        }
                    </td> : null}
                </tr>
            )
        }
        else {
            // si no esta definido, mostrar el formulario para agregarlo
            return (
                <tr key={2}>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>{ }</td>
                    <td className={css.tdUsuarioRUN}>
                        {/* {this.props.editable ?
                            <InputRun key={1}
                                onPressEnter={this.onPressEnter.bind(this)}
                                onRUNChange={this.onRUNChange.bind(this)}
                            />
                            :
                            null
                        } */}
                    </td>
                    <td className={css.tdUsuarioDV}>
                        {this.props.editable ?
                            <input type="text" value={''} disabled ref={ref => this.ref_usuarioDV = ref} />
                            :
                            null
                        }
                    </td>
                    <td>
                        {/* Nombre */}
                    </td>
                    <td>
                        {/* Comuna */}
                    </td>
                    <td>
                        {/* Captador */}
                    </td>
                    <td>
                        {/* Experiencia */}
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>

                </tr>
            )
        }
    }
}
RowOperadorReemplazo.propTypes = {
    editable: PropTypes.bool.isRequired,
    //editarTodasNominas: PropTypes.bool.isRequired,
    correlativo: PropTypes.string.isRequired,
    personal: PropTypes.object,
    cargo: PropTypes.string,
}


export class RowOperadorReemplazoSEI extends React.Component {

    constructor(props) {
        super(props)
        this.state = { checkbox: this.props.checkboxStatus, showModal: false, showModalCaptador: false }
    }
    handleClick() {
        const fechaInventario = new Date(`${this.props.fechaInventario}T09:00:00`);
        const fechaActual = new Date();
        if (fechaInventario.toDateString() === fechaActual.toDateString() && fechaActual > fechaInventario) {
            this.setState({ showModal: true })
        } else {
            this.setState({ showModal: false })
            if (this.props.personal.esLider == false && this.props.personal.idCaptador == 1) {
                this.setState({ showModalCaptador: true })
            } else {
                this.props.cambiarDePanel(this.props.personal.id, false, this.props.personal.idCaptador);
            }
        }
    }
    hideModal() {
        this.setState({ showModal: false, showModalCaptador: false })
    }
    onPressEnter(run) {
        this.ref_usuarioDV.value = ''
        this.props.agregarUsuario(run)
    }
    onRUNChange(usuarioRUN, usuarioDV) {
        // a medida que escriben el rut, se ira actualizando el DV
        this.ref_usuarioDV.value = usuarioDV
    }
    handleChange(event) {
        // console.log(event.target.disabled)
        this.props.setStatusCheckBox(this.props.personal.id, event.target.checked);
        this.setState({ checkbox: event.target.checked })
    }

    handleChangeEnroque(event) {
        this.props.setStatusCheckBoxEnroqueReemplazo(this.props.personal.id, event.target.checked, this.props.personal.nombreCorto, this.props.personal.unidadesContadas);
        this.setState({ checkbox: event.target.checked })
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({ checkbox: nextProps.checkboxStatus });
        }
    }
    render() {
        if (this.props.personal) {
            const isPermisoMall = this.props.isPermisoMall;
            const tienePermisoMall = this.props.tienePermisoMall ? this.props.tienePermisoMall : false
            // console.log('2', this.props.personal);
            const condiciones = this.props.personal.experienciaComoOperador <= 4 || this.props.personal.error > 0.5;
            const shouldDisable = this.props.puedeAsignar ? false : (this.props.cliente == 12 || this.props.cliente == 24 ? condiciones : false);
            // si el operador esta definido, mostrar sus datos
            return (
                <tr style={{ backgroundColor: (this.props.personal.asistencia == -1 ? 'rgb(243, 182, 182)' : (this.props.personal.esLider ? 'rgb(233, 243, 252)' : '')) }}>
                    {this.props.activarPermisoMall
                        ? [
                            <td key={'A1'}>{this.props.correlativo}</td>,
                            <td key={'A2'} colSpan="2">
                                <InputOperadorPermisoMall
                                    disabled={tienePermisoMall}
                                    idNomina={this.props.idNomina}
                                    idOperador={this.props.personal.id}
                                    incluir_permisomall={this.props.personal.incluir_permisomall}
                                    orden_permisomall={this.props.personal.orden_permisomall}
                                    //selectedPermisoId={this.props.selectedPermisoId}
                                    permisoCompleto={this.props.permisoCompleto}
                                    notificator={this.props.notificator}
                                />
                            </td>,
                            <td key={'A3'}>
                                {this.props.personal.incluir_permisomall ? this.props.personal.orden_permisomall : ""}
                            </td>
                        ]
                        : [
                            <td key={'B1'}>
                                {this.props.editable ? <OperadorEscondido index={this.props.correlativo} idUser={this.props.personal.id}
                                    funcion={this.props.operadorEscondido} nombre={this.props.personal.nombreCorto} /> : this.props.correlativo}
                            </td>,
                            <td key={'B2'}>
                                {this.state.showModal && <ModalReemplazoPorBaja cambiarPanel={this.props.cambiarDePanel} id={this.props.personal.id}
                                    captador={this.props.idCaptador} hideModal={this.hideModal.bind(this)} operador={this.props.personal.nombreCorto} />}
                                {this.state.showModalCaptador && <ModalReemplazoCaptador cambiarPanel={this.props.cambiarDePanel} id={this.props.personal.id}
                                    captador={this.props.personal.idCaptador} hideModal={this.hideModal.bind(this)} operador={this.props.personal.nombreCorto} cambiarCaptador={this.props.cambiarCaptador} />}
                                {(this.props.editable && this.props.cargo == 'Operador') ?
                                    <button className="btn btn-xs btn-success glyphicon glyphicon-triangle-left"
                                        onClick={this.handleClick.bind(this)}
                                        title="Cambiar a nómina titular"
                                        disabled={shouldDisable}
                                    >
                                    </button>
                                    :
                                    (this.props.enroque ?
                                        <input type="checkbox" onChange={this.handleChangeEnroque.bind(this)} checked={shouldDisable ? false : this.state.checkbox} disabled={shouldDisable} />
                                        : null)
                                }
                            </td>,
                            <td key={'B3'}>
                                {/*<button className="btn btn-xs btn-warning glyphicon glyphicon-remove" disabled={this.props.operadorTitularId}
                                        onClick={()=>{ this.props.quitarUsuario(this.props.personal.id, false) }}
                                        title="Quitar Operador nómina reemplazo"
                            ></button>*/}
                                {this.props.editable ?
                                    <input type="checkbox" onChange={this.handleChange.bind(this)} checked={shouldDisable ? false : this.state.checkbox} disabled={shouldDisable} />
                                    :
                                    null
                                }
                            </td>,
                            <td key={'B4'}>
                                {/*<button className="btn btn-xs btn-warning glyphicon glyphicon-ban-circle" disabled={this.props.operadorTitularId}
                                        onClick={()=>{ this.props.suspendOperator(this.props.personal) }}
                                        title="Suspender operador"
                            ></button>*/}
                                {this.props.editable ?
                                    <button className="btn btn-xs btn-warning glyphicon glyphicon-remove" disabled={this.props.operadorTitularId}
                                        onClick={() => { this.props.quitarUsuario(this.props.personal.id, false) }}
                                        title="Quitar Operador nómina reemplazo"
                                    ></button>
                                    :
                                    null
                                }
                            </td>
                        ]}
                    <td className={css.tdUsuarioRUN}>
                        {this.props.personal.escondido ? <p className={css.textoConTooltip} style={{ overflow: 'hidden' }} >
                            <strong style={{ color: 'rgb(16, 138, 198)' }}>
                                <input type="text" value={this.props.personal.usuarioRUN} disabled />
                            </strong>
                            <span>Operador Escondido</span>
                        </p> : (this.props.personal.bloqueadoLider
                            ? <p className={css.textoConTooltip} style={{ overflow: 'hidden' }} >
                                <strong style={{ color: 'darkviolet' }}>
                                    <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                </strong>
                                <span>{MESSAGE}</span>
                            </p> :
                            this.props.personal.bloqueado
                                ? <strong style={{ color: 'red' }}>
                                    <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                </strong> :
                                (this.props.personal.bloqueadoCliente
                                    ? <strong style={{ color: 'orange' }}>
                                        <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                    </strong> :
                                    (this.props.personal.bloqueadoLocal
                                        ? <strong style={{ color: 'rgb(16, 185, 129)' }}>
                                            <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                        </strong> :
                                        (this.props.personal.incompatibles.length > 0
                                            ? <p className={css.textoConTooltip} style={{ overflow: 'hidden' }} >
                                                <strong style={{ color: 'rgb(27, 36, 130)' }}>
                                                    <input type="text" value={this.props.personal.usuarioRUN} style={{ cursor: 'help' }} disabled />
                                                </strong>
                                                <span>Incompatible con:
                                                    <div style={{ display: 'block', marginTop: '8px' }}>
                                                        {this.props.personal.incompatibles.map((incompatible, index) => (
                                                            <div key={index}>{incompatible}</div>
                                                        ))}
                                                    </div>
                                                </span>
                                            </p> : <input type="text" value={this.props.personal.usuarioRUN} disabled />
                                        ))))
                        }
                    </td>
                    <td className={css.tdUsuarioDV}>
                        {this.props.personal.escondido ?
                            <strong style={{ color: 'rgb(16, 138, 198)' }}>
                                <input type="text" value={this.props.personal.usuarioDV} disabled />
                            </strong> : (this.props.personal.bloqueadoLider
                                ? <strong style={{ color: 'darkviolet' }}>
                                    <input type="text" value={this.props.personal.usuarioDV} disabled />
                                </strong> : this.props.personal.bloqueado
                                    ? <strong style={{ color: 'red' }}>
                                        <input type="text" value={this.props.personal.usuarioDV} disabled />
                                    </strong> :
                                    (this.props.personal.bloqueadoCliente
                                        ? <strong style={{ color: 'orange' }}>
                                            <input type="text" value={this.props.personal.usuarioDV} disabled />
                                        </strong> :
                                        (this.props.personal.bloqueadoLocal
                                            ? <strong style={{ color: 'rgb(16, 185, 129)' }}>
                                                <input type="text" value={this.props.personal.usuarioDV} disabled />
                                            </strong> :
                                            <input type="text" value={this.props.personal.usuarioDV} disabled />
                                        )))
                        }
                    </td>


                    <td className={this.props.personal.idnominatitular > 0 ? css.operadorEnOtraNominaMismoDia : css.tdNombre}>

                        {this.props.personal.idnominatitular > 0 ?
                            <p className={css.textoConTooltip} style={{ overflow: 'hidden' }} >
                                <input type="text" value={this.props.personal.nombreCorto} disabled />
                                <span>{this.props.personal.datos_nomina_titular}</span>
                            </p>
                            :
                            (
                                this.props.personal.asistencia == -2
                                    ? <p className={css.textoConTooltip} style={{ overflow: 'hidden' }} >
                                        <div style={{ position: 'relative' }}>
                                            <input type="text" value={this.props.personal.nombreCorto} disabled />
                                            <div className='glyphicon glyphicon-exclamation-sign' style={{ position: 'absolute', top: 0, right: 0, color: 'orange' }}></div>
                                        </div>
                                        <span>Op. canceló inventario</span>
                                    </p>
                                    : <input type="text" value={this.props.personal.nombreCorto} disabled />)
                        }

                    </td>
                    <td>
                        {this.props.personal.comuna}
                    </td>
                    <td className={css.tdCaptador}>
                        {this.props.personal.captador}
                    </td>
                    <td>
                        {this.props.cargo == 'Lider' ? `${this.props.personal.experienciaComoLider}` : ''}
                        {this.props.cargo == 'Supervisor' ? `${this.props.personal.experienciaComoSupervisor}` : ''}
                        {this.props.cargo == 'Operador' ? `${this.props.personal.experienciaComoOperador}` : ''}
                    </td>
                    <td className={css.tdError}>
                        {this.props.personal.error ? (this.props.personal.error >= 1 ? <strong style={{ color: 'red' }}>{this.props.personal.error}</strong> : this.props.personal.error) : 0}
                    </td>
                    <td className={css.tdConteo}>
                        {this.props.personal.unidadesContadas ? this.props.personal.unidadesContadas : ''}
                    </td>
                    <td className={css.tdConteoReal}>
                        {this.props.personal.unidadesContadasReal ? this.props.personal.unidadesContadasReal : ''}
                    </td>
                    <td className={this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? css.aprobado_2 : this.props.personal.idEstadoContrato == 2 ? css.aprobado_1 : this.props.personal.idEstadoContrato == 1 ? css.pendiente_2 : css.pendiente_3}>
                        {this.props.personal.idEstadoContrato == 2 && this.props.personal.isValido == 1 ? 'Aprobado' : this.props.personal.idEstadoContrato == 2 ? 'Vigente' : this.props.personal.idEstadoContrato == 1 ? 'Pendiente' : 'Pendiente'}
                    </td>
                    <td>
                        <span title={this.props.personal.estadoCI}>
                            {this.props.personal.estadoCI === 'Vigente' && <span className={css.emoji_verde}>✅</span>}
                            {this.props.personal.estadoCI === 'Próximo a vencer' && <span className={css.emoji_amarillo}>⚠️</span>}
                            {this.props.personal.estadoCI === 'Vencido' && <span className={css.emoji_rojo}>❌</span>}
                            {!['Vigente', 'Próximo a vencer', 'Vencido'].includes(this.props.personal.estadoCI) &&
                                <span className={css.emoji_gris}>⚪</span>
                            }
                        </span>
                    </td>
                    {isPermisoMall ? <td>
                        {tienePermisoMall
                            ? <div className='glyphicon glyphicon-ok' style={{ color: 'green', fontSize: '16px' }}></div>
                            : <div className='glyphicon glyphicon-remove' style={{ color: 'red', fontSize: '16px' }}></div>
                        }
                    </td> : null}
                </tr>
            )
        }
        else {
            // si no esta definido, mostrar el formulario para agregarlo
            return (
                <tr key={2}>
                    <td>
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>
                    <td>{ }</td>
                    <td className={css.tdUsuarioRUN}>
                        {this.props.editable ?
                            <InputRun key={1}
                                onPressEnter={this.onPressEnter.bind(this)}
                                onRUNChange={this.onRUNChange.bind(this)}
                            />
                            :
                            null
                        }
                    </td>
                    <td className={css.tdUsuarioDV}>
                        {this.props.editable ?
                            <input type="text" value={''} disabled ref={ref => this.ref_usuarioDV = ref} />
                            :
                            null
                        }
                    </td>
                    <td>
                        {/* Nombre */}
                    </td>
                    <td>
                        {/* Comuna */}
                    </td>
                    <td>
                        {/* Captador */}
                    </td>
                    <td>
                        {/* Experiencia */}
                    </td>
                    <td>
                        { }
                    </td>
                    <td>
                        { }
                    </td>

                </tr>
            )
        }
    }
}
RowOperadorReemplazoSEI.propTypes = {
    editable: PropTypes.bool.isRequired,
    //editarTodasNominas: PropTypes.bool.isRequired,
    correlativo: PropTypes.string.isRequired,
    personal: PropTypes.object,
    cargo: PropTypes.string,
    enroque: PropTypes.bool
}

const OperadorEscondido = ({ index, idUser, funcion, nombre }) =>
    <ModalTrigger>
        {(isVisible, showModal, hideModal) =>
            <div onClick={showModal}>
                <div style={{ cursor: 'pointer' }}>{index}</div>
                {isVisible && <ModalOperadorEscondido
                    operador={nombre}
                    id={idUser}
                    setEscondido={funcion}
                    hideModal={hideModal}
                />}
            </div>
        }
    </ModalTrigger>


export class InputOperadorPermisoMall extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            checkbox: this.props.incluir_permisomall,
            loading: false
        }
    }

    handleChange = (event) => {
        const checked = event.target.checked
        //const selectedPermisoId = this.props.selectedPermisoId
        this.setState({ checkbox: checked, loading: true });
        if (checked) {
            this.context.updateNominaPermisoMall(this.props.idOperador, checked, 0)
        }
        fetch(`/api/nomina/incluir-permisomall`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                idNomina: this.props.idNomina,
                idOperador: this.props.idOperador,
                incluir_permisomall: checked,
                //selectedPermisoId: selectedPermisoId
            }),
        })
            .then(response => {
                return response.json().then(json => {
                    if (!response.ok) {
                        throw json;
                    }
                    return json;
                });
            })
            .then(dataResponse => {
                const {message, data} = dataResponse
                this.context.updateNominaPermisoMall(this.props.idOperador, checked, data.orden)
                this.props.notificator.success('Permiso mall actualizado', 'El permiso mall se actualizó correctamente', 4 * 1000);
            })
            .catch((error) => {
                this.props.notificator.error('Error al actualizar el permiso mall', error, 4 * 1000);
                this.setState({ checkbox: this.props.incluir_permisomall });
            }).finally(() => {
                this.setState({ loading: false });
            });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.incluir_permisomall != this.props.incluir_permisomall) {
            const nextChecked = this.props.incluir_permisomall
            if (this.state.checkbox != nextChecked) {
                this.setState({ checkbox: nextChecked })
            }
        }
    }

    render() {
        return (
            <div className='text-center'>
                <input type="checkbox"
                    disabled={(this.props.permisoCompleto && !this.state.checkbox) || this.state.loading || this.props.disabled}
                    checked={this.state.checkbox}
                    onChange={this.handleChange}
                    style={{ height: '20px', width: '20px' }}
                />
            </div>
        )
    }
}

InputOperadorPermisoMall.propTypes = {
    idNomina: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    idOperador: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    incluir_permisomall: PropTypes.oneOfType([PropTypes.bool]).isRequired,
    //selectedPermisoId: PropTypes.string,
}

InputOperadorPermisoMall.contextTypes = {
    updateNominaPermisoMall: PropTypes.func,
}


// WEBPACK FOOTER //
// ./frontEnd/nominas/nominaIG/components/RowOperador.jsx